export default class LoginModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
